import {BaseContainerModel} from '../../base-container.model';
import {
  bl_crm_membership_points_currency_hdr_RowClass,
  bl_fi_item_review_rating_config_hdr_RowClass,
  bl_fi_mst_attribute_ext_RowClass,
  bl_fi_mst_attribute_hdr_RowClass,
  bl_fi_mst_label_hdr_RowClass,
  bl_fi_mst_search_filter_section_RowClass,
  bl_fi_mst_search_filter_set_RowClass,
} from '../../../dbschema';

export class SearchFilterContainerModel extends BaseContainerModel {
  bl_fi_mst_label_hdr: bl_fi_mst_label_hdr_RowClass = new bl_fi_mst_label_hdr_RowClass();
  bl_fi_mst_search_filter_sets: bl_fi_mst_search_filter_set_RowClass[] = [];
  bl_fi_mst_search_filter_sections:bl_fi_mst_search_filter_section_RowClass[] = [];
  bl_fi_mst_attribute_hdr: bl_fi_mst_attribute_hdr_RowClass[] = [];
  bl_fi_mst_attribute_exts: bl_fi_mst_attribute_ext_RowClass[] = [];
  bl_crm_membership_points_currencies: bl_crm_membership_points_currency_hdr_RowClass[] = [];
  bl_fi_item_review_rating_config_hdrs: bl_fi_item_review_rating_config_hdr_RowClass[] = [];
}
